/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeExcuseStatusCommand } from '../../models/change-excuse-status-command';
import { ChangeExcuseStatusCommandResult } from '../../models/change-excuse-status-command-result';

export interface ApiPlanChangeExcuseStatusPost$Plain$Params {
  
    /**
     * Change Excuse Status
     */
    body?: ChangeExcuseStatusCommand
}

export function apiPlanChangeExcuseStatusPost$Plain(http: HttpClient, rootUrl: string, params?: ApiPlanChangeExcuseStatusPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeExcuseStatusCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanChangeExcuseStatusPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChangeExcuseStatusCommandResult>;
    })
  );
}

apiPlanChangeExcuseStatusPost$Plain.PATH = '/api/Plan/ChangeExcuseStatus';
